'use client'
import { ReactElement } from 'react'
import { createUrl } from '@/lib/utils/create-url'

interface ImageProps {
  width: number
  height?: number
  filename: string
  alt?: string
  className?: string
  strategy?: string
}

export function Image(props: ImageProps): ReactElement {
  return (
    <img
      src={createUrl(props.filename, props.width, props.height, props.strategy)}
      srcSet={`${createUrl(
        props.filename,
        props.width,
        props.height,
        props.strategy,
      )} 1x, ${createUrl(
        props.filename,
        props.width * 2,
        props.height !== undefined ? props.height * 2 : undefined,
        props.strategy,
      )} 2x`}
      loading="lazy"
      alt={props.alt}
      width={props.width}
      height={props.height}
      className={props.className}
    ></img>
  )
}
